import { dashboardStatusHexColors } from '../../../constants/integrationTypes';

export interface ProgressCircleProps {
    /** Progress value (0-100) */
    progress: number;
    /** Size of the circle in pixels */
    size?: number;
    /** Width of the stroke in pixels */
    strokeWidth?: number;
    /** Color of the progress arc (hex or CSS color) */
    color?: string;
    /** Whether to show percentage text inside */
    showPercentage?: boolean;
    /** Optional className for the container */
    className?: string;
}

// Default Cadence primary color from tailwind.config.js
export const CADENCE_PRIMARY = '#1d64f3';

export const PROGRESS_CIRCLE_DEFAULTS = {
    size: 64,
    strokeWidth: 6,
    color: CADENCE_PRIMARY, // Cadence primary blue
    showPercentage: true,
} as const;

// Re-export status colors from integrationTypes for convenience
export const STATUS_COLORS = dashboardStatusHexColors;
